module.exports = __webpack_public_path__ + "img/jb-qz4078_b_6.prt.da9f2c7f.jpg";